// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 683) return "js/chunk.npm-async-@radix-ui.99fa6a17.js";
	if (chunkId === 945) return "js/chunk.945.692cdfef.js";
	if (chunkId === 367) return "js/chunk.367.9510a895.js";
	if (chunkId === 813) return "js/chunk.813.13ac5d39.js";
	if (chunkId === 316) return "js/chunk.npm-async-lucide-react.41cf6b52.js";
	if (chunkId === 850) return "js/chunk.npm-async-embla-carousel.a0fce608.js";
	if (chunkId === 326) return "js/chunk.npm-async-embla-carousel-reactive-utils.172c2467.js";
	if (chunkId === 320) return "js/chunk.npm-async-embla-carousel-react.c1ba1866.js";
	if (chunkId === 430) return "js/chunk.430.698416e1.js";
	if (chunkId === 533) return "js/chunk.npm-async-@tanstack.df13a18e.js";
	if (chunkId === 254) return "js/chunk.254.e83656c3.js";
	if (chunkId === 709) return "js/chunk.709.171c4066.js";
	if (chunkId === 250) return "js/chunk.250.c533833d.js";
	if (chunkId === 861) return "js/chunk.861.17432b91.js";
	if (chunkId === 193) return "js/chunk.npm-async-@atlaskit.87aadd53.js";
	if (chunkId === 335) return "js/chunk.app-async.27eee69c.js";
	if (chunkId === 38) return "js/chunk.npm-async-@babel.7f3cad36.js";
	if (chunkId === 853) return "js/chunk.npm-async-@emotion.56ea618b.js";
	if (chunkId === 404) return "js/chunk.npm-async-stylis.201f7fa1.js";
	if (chunkId === 565) return "js/chunk.npm-async-@lit.9f561e42.js";
	if (chunkId === 921) return "js/chunk.npm-async-lit.49f13f5f.js";
	if (chunkId === 117) return "js/chunk.npm-async-bind-event-listener.b75f5bb2.js";
	if (chunkId === 102) return "js/chunk.npm-async-@toeverything.bec9815c.js";
	if (chunkId === 427) return "js/chunk.npm-async-@vanilla-extract.64338416.js";
	if (chunkId === 107) return "js/chunk.npm-async-@blocksuite.bd709fa7.js";
	if (chunkId === 628) return "js/chunk.npm-async-raf-schd.987d8edb.js";
	if (chunkId === 422) return "js/chunk.npm-async-lottie-web.c528426d.js";
	if (chunkId === 977) return "js/chunk.npm-async-lottie-react.884059ce.js";
	if (chunkId === 929) return "js/chunk.npm-async-dayjs.f3726f4f.js";
	if (chunkId === 500) return "js/chunk.500.017fb656.js";
	// return url for filenames based on template
	return undefined;
};